import React, { useEffect } from "react";
import { getCalApi } from "@calcom/embed-react";
import Button, { ButtonProps } from "@components/ui/button";
import { toSentenceCase } from "@/utils"

interface ScheduleButtonProps extends ButtonProps {}

const ScheduleButton: React.FC<ScheduleButtonProps> = ({ children, ...props }) => {
  useEffect(() => {
    (async function () {
      const cal = await getCalApi();
      cal("ui", {
        theme: "light",
        styles: { branding: { brandColor: "#059669" } },
        hideEventTypeDetails: false,
        layout: "month_view"
      });
    })();
  }, []);

  const transformedChildren = React.Children.map(children, child => {
    if (typeof child === "string") {
      return toSentenceCase(child);
    }
    return child;
  });

  return (
    <Button
      data-cal-namespace=""
      data-cal-link="railsfactory/get-connect-with-us"
      data-cal-config='{"layout":"month_view"}'
      {...props}
    >
      {transformedChildren}
    </Button>
  );
};
export default ScheduleButton;
